/**
 * Guard: chỉ cho phép truy cập route khi user có permission tương ứng.
 * Dùng getEffectivePermissions (roles + direct permissions) từ localStorage.
 */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from 'ui-component/Loader';
import { getUserContext, getEffectivePermissions, hasPermission } from '../rbac';

/**
 * Permission cần cho module Tổng hợp & Hỏi đáp tài liệu nghiên cứu.
 * Có thể dùng research_docs:read hoặc research_docs:*.
 */
export const RESEARCH_DOCS_READ = 'research_docs:read';
export const RESEARCH_DOCS_RESOURCE = 'research_docs';
export const RESEARCH_DOCS_ACTION_READ = 'read';

const RequirePermission = ({ children, resource, action, fallbackPath = '/workspace/storage' }) => {
    const navigate = useNavigate();

    const { user_roles = [], user_permissions = [] } = getUserContext();
    const hasRbacData = (user_roles && user_roles.length > 0) || (user_permissions && user_permissions.length > 0);
    const effective = getEffectivePermissions(user_roles || [], user_permissions || []);
    const allowed = !hasRbacData || hasPermission(effective, resource, action);

    useEffect(() => {
        if (!allowed) {
            navigate(fallbackPath, { replace: true });
        }
    }, [allowed, navigate, fallbackPath]);

    if (!allowed) {
        return <Loader />;
    }
    return children;
};

RequirePermission.propTypes = {
    children: PropTypes.node,
    resource: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    fallbackPath: PropTypes.string
};

export default RequirePermission;
